//require('./guestsBootstrap');
require('./navbar-scroll')
require('./navbar-responsive')
require('./open-popup')
require('./offers-filters')
require('./faq')
require('./flat-picker')
require('./go-back')
require('./concept-pictos-popup')

//import { createApp, h } from 'vue';
